<template>
  <b-form-input
    v-model="value"
    class="d-inline-block mr-1"
    :placeholder="`${$t('Search')}...`"
    @keyup="search"
  />
</template>

<script>
import {
  BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'ListSearch',
  components: {
    BFormInput,
  },
  data() {
    return {
      value: '',
      timeout: null,
      debounce: 1,
    }
  },
  methods: {
    search() {
      // clear timeout variable
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.$emit('onSearch', this.value), this.debounce * 1000)
    },
  },
}
</script>

<style scoped>

</style>
